import { useMemo } from 'react';
import { useRouter } from 'next/router';

/**
 *
 * @param key the query key
 * @returns the query value to the query key
 */
export const useNextQueryParam = (key: string): string | undefined => {
  const { asPath, query } = useRouter();

  return useMemo(() => {
    if (query[key]) return query[key] as string;

    const match = asPath.match(new RegExp(`[&?]${key}=(.*?)(&|$)`));
    if (!match) return undefined;
    return decodeURIComponent(match[1]);
  }, [asPath, key, query]);
};
